import {Button, ButtonProps, useStyleConfig, useMediaQuery} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends ButtonProps {
  title?: string;
  selected?: boolean;
}

// variant?: 'primary' | 'white' | 'toggle' | 'outline' | 'solid';
export const UiButton = memo(
  React.forwardRef<HTMLButtonElement, ButtonProps>(({title, children, variant = 'primary', ...rest}: Props, ref) => {
    const bntTitle = title || children;
    const styles = useStyleConfig('Button', {variant});

    return (
      <Button ref={ref} {...rest} __css={styles}>
        {bntTitle}
      </Button>
    );
  }),
);
